import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './Router';
import './index.scss';

ReactDOM.render(<AppRouter />, document.querySelector('.main-container'));
